<template>
  <div>
    <div class="pagePopMask pFull" v-if="infoPop" @click="cancelImpEdit"></div>
    <div class="pagePop w1280 pCenter" v-if="infoPop">
      <div class="w">
        <div class="tit fnt_32">{{ globalDataArray.siteTemplateLanguage.modify_information }}</div>
        <div>
          <div class="stform">
            <a-form-model ref="realForm" :model="studentInfo">
              <a-row :gutter="16">
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item :label="globalDataArray.siteTemplateLanguage.name_text" prop="nickname">
                    <a-input v-model="studentInfo.nickname" disabled />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item :label="globalDataArray.siteTemplateLanguage.phone" prop="name">
                    <a-input v-model="studentInfo.phone" disabled />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item :label="globalDataArray.siteTemplateLanguage.site_email" prop="name">
                    <a-input v-model="studentInfo.email" disabled />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item :label="globalDataArray.siteTemplateLanguage.personal_area" prop="name">
                    <a-input v-model="studentInfo.address" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item :label="globalDataArray.siteTemplateLanguage.team_user_company_name" prop="name">
                    <a-input v-model="studentInfo.company" />
                  </a-form-model-item>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                  <a-form-model-item :label="globalDataArray.siteTemplateLanguage.receiving_address" prop="name">
                    <a-input v-model="studentInfo.deliveryAddress" />
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form-model>
          </div>
        </div>
        <div class="btnBox fnt_18">
          <div class="btn btn1" @click="confirmImpEdit">{{ globalDataArray.siteTemplateLanguage.save }}</div>
          <div class="btn btn2" @click="cancelImpEdit">{{ globalDataArray.siteTemplateLanguage.cancel }}</div>
        </div>
        <div class="close" @click="cancelImpEdit"></div>
      </div>
    </div>
  </div>
</template>
<script>

import { updateMember } from '@/api/person/person'

export default {
  name: 'PersonInfoEdit',
  props: {
    infoPop: {
      type: Boolean,
      default: false
    },
    person: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      studentInfo: {
        ...this.person
      }
    }
  },
  watch: {
    infoPop: {
      immediate: true,
      handler(val) {
        if (val) {
          this.studentInfo = structuredClone(this.person)
        }
      }
    }
  },
  mounted() {
  },
  methods: {
    confirmImpEdit() {
      console.log(this.studentInfo)
      this.$refs['realForm'].validate(async (err, valid) => {
        if (err) {
          const param = structuredClone(this.studentInfo)
          delete param.email
          delete param.phone
          const res = await updateMember(param)
          if (res.success) {
            this.$message.success(this.globalDataArray.siteTemplateLanguage.update_success || '修改成功')
            this.$emit('update:infoPop', false)
            this.$emit('init')
          }
        } else {
          return false
        }
      })
    },
    cancelImpEdit() {
      this.$emit('update:infoPop', false)
    }
  }
}
</script>

<style scoped>
::v-deep .ant-input-disabled {
  background-color: #f7f7f7;
  color: rgba(0, 0, 0, 0.65) !important;
}
</style>
